export default __webpack_public_path__ + "static/media/frown.9685acfe.svg";